import { ThemeProvider, createTheme } from "@mui/material/styles";
import { CssBaseline, Tabs, Tab } from "@mui/material";
import { BrowserRouter as Router, Routes, Route, useNavigate, useLocation } from "react-router-dom";

import { Typography, Box, Paper, Grid } from "@mui/material"; // Importa los componentes de Material UI para la interfaz
import Sounds from "./components/Sounds.jsx";
import Interact from "./components/Interact.jsx";
import Students from "./components/Students.jsx";
import ContactUs from "./components/ContactUs.jsx";
import Welcome from "./components/Welcome.jsx";

const darkTheme = createTheme({
  palette: { mode: "dark" },
});

// Mapea cada Tab a su ruta real
const TABS = [
  { label: "Sonidos", path: "/sonidos" },
  { label: "Interactuar", path: "/apps" },
  { label: "Estudiantes", path: "/estudiantes" },
  { label: "Contáctanos", path: "/contacto" },
];

function AppShell() {
  const navigate = useNavigate();
  const location = useLocation();

  // Determina qué tab está activa según la URL actual
  const currentTab = TABS.findIndex((t) => location.pathname.startsWith(t.path));

  const changeTab = (event, newTab) => {
    navigate(TABS[newTab].path);
  };

  return (
    <ThemeProvider theme={darkTheme}>
      <CssBaseline />
      <Welcome />

      <Tabs value={currentTab === -1 ? false : currentTab} onChange={changeTab} centered>
        {TABS.map((t) => (
          <Tab key={t.path} label={t.label} />
        ))}
      </Tabs>

      <Routes>
        <Route path="/" element={null} />
        <Route path="/sonidos/*" element={<Sounds />} />
        <Route path="/apps/*" element={<Interact />} />
        <Route path="/estudiantes" element={<Students setTab={changeTab} />} />
        <Route path="/contacto" element={<ContactUs />} />
      </Routes>
    </ThemeProvider>
  );
}

export default function App() {
  return (
    <Router basename="/labvs">
      <AppShell />
    </Router>
  );
}